import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Appaling customer service at Harvey Norman",
  "description": "",
  "published": "2008-01-19T00:00:00.000Z",
  "redirect_from": ["/blog/appaling-customer-service-at-harvey-norman/swizec/133"],
  "categories": "life, review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Harvey Norman Ljubljana has appaling customer service as I have often before been slightly aluded to, but in the past few weeks it was proven beyond a doubt.`}</p>
    <p>{`As some of you might know, mostly because I shoved it down your throats, a fortnight ago `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=294"
      }}>{`my graphics card died`}</a>{` in a blaze of hot glory and consequently I went to have it fixed at the place I bought it - Harvey Norman. At first I had to wait quite a while for someone to come and see me at the service counter where the neatly packaged card, original packaging and all, was checked in.`}</p>
    <p>{`Then last thursday, that's two days ago now, I receive a call on my cell and a guy told me I can come pick up the card, so later that day I did. Once again i was faced with waiting quite a while before anybody came and they give me the packaged card and I sign the paper saying I got it. Something told me to look in the package and so I did. What do I find?`}</p>
    <p>{`Not only was the card not fixed, it even contained the same few specks of dust at the same place they were before - and they ripped my lovely box a little. So I ask what the flying fuck is going on? Why the hell isn't my card fixed and how come it even looks completely untouched? The clerk gave me a compassionate response that he isn't one of the service people, that they work in the mornings and he can't tell me anything about anything. I should call or come next morning.`}</p>
    <p>{`And so I did call next morning, well, at 2pm, but verily that's not very late afternoon even for a Friday, where I work we stay there until 6pm on Fridays, sometimes even later still. Needless to say I didn't quite manage to speak to any of the service people, as simple as nobody picking up the phone. I was told after the second redirect try that I'd be redirected to the computer section rather than computer service section, but talking to those clerks doesn't really do me any good so I hung up before the call went through.`}</p>
    <p>{`I have a suspicion that if I call right now, being Saturday, there won't be any service people there. So I'm pinning my hopes on Monday to have this mess cleared up and told why the hell is my card still out of order.`}</p>
    <p>{`Definitely never shoppping there again though ... never again.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      